export default __webpack_public_path__ + "static/habitat-f5b47c236807eb2b3ef1ff072879c4d0.png";